import api from '@/api';
import { API_BASE_URL } from '..';
import {
  WorkOrderChecklistAccessory,
  WorkOrderChecklistAccessoryCreate,
  WorkOrderChecklistAccessoryListRequest,
  WorkOrderChecklistComplementItem,
  WorkOrderChecklistComplementItemCreate,
  WorkOrderChecklistComplementItemsListRequest,
  WorkOrderChecklistDamage,
  WorkOrderChecklistDamageCreate,
  WorkOrderChecklistDamageListRequest,
  WorkOrderChecklistFutureService,
  WorkOrderChecklistFutureServiceCreate,
  WorkOrderChecklistFutureServiceEdit,
  WorkOrderChecklistFutureServiceImportExcludedServices,
  WorkOrderChecklistFutureServiceListRequest,
  WorkOrderChecklistFutureServiceToWorkorder,
  WorkOrderChecklistImageResponse,
  WorkOrderChecklistQuick,
  WorkOrderChecklistQuickCreate,
  WorkOrderChecklistQuickListRequest,
  ReportChecklistRequest,
  WorkOrderChecklistRequestService,
  WorkOrderChecklistRequestServiceCreateRequest,
  WorkOrderChecklistRequestServiceListRequest,
  WorkOrderImagesCreateRequest,
  WorkOrderImagesListRequest,
  ReportChecklistData,
  ReportChecklistPublicData,
  ChecklistSignatureWithTokenRequest,
  ChecklistImageMultipleRemoveRequest,
  ChecklistObservationsListRequest,
  ChecklistObservationListResponse,
  ChecklistObservationRequest,
  WorkOrderChecklistRequestServiceUpdateRequest,
} from './WorkOrdersChecklist.types';
import { publicInstance } from '@/api/axiosInstance';

const CONTROLLER_URL = `${API_BASE_URL}/Checklist`;

const workorderChecklistServices = {
  async addImages(data: WorkOrderImagesCreateRequest) {
    const result = (await api.post(`${CONTROLLER_URL}/Image`, data)) as unknown;

    return result as void;
  },

  async listImages(params?: WorkOrderImagesListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetImage`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistImageResponse;
  },

  async removeImages(id: number) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/Image/${id}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },

  async removeMultipleImages(params: ChecklistImageMultipleRemoveRequest) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/Image/list`,
      params,
      null,
    )) as unknown;

    return result as void;
  },

  async addRequestService(data: WorkOrderChecklistRequestServiceCreateRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/RequestedService`,
      data,
    )) as unknown;

    return result as void;
  },

  async listRequestService(
    params?: WorkOrderChecklistRequestServiceListRequest,
  ) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetRequestService`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistRequestService[];
  },

  async removeRequestService(id: number) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/RequestService/${id}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },

  async updateRequestService(
    data: WorkOrderChecklistRequestServiceUpdateRequest,
  ) {
    const result = (await api.put(
      `${CONTROLLER_URL}/RequestService/${data.id}`,
      data,
      null,
    )) as unknown;

    return result as void;
  },

  async addQuick(data: WorkOrderChecklistQuickCreate) {
    const result = (await api.post(`${CONTROLLER_URL}/Quick`, data)) as unknown;

    return result as void;
  },

  async listQuick(params?: WorkOrderChecklistQuickListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetQuick`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistQuick[];
  },

  async addAccessory(data: WorkOrderChecklistAccessoryCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/Accessory`,
      data,
    )) as unknown;

    return result as void;
  },

  async listAccessory(params?: WorkOrderChecklistAccessoryListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetAccessory`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistAccessory[];
  },

  async addComplementItem(data: WorkOrderChecklistComplementItemCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/ComplementaryItems`,
      data,
    )) as unknown;

    return result as void;
  },

  async listComplementItem(
    params?: WorkOrderChecklistComplementItemsListRequest,
  ) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetComplementaryItems`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistComplementItem[];
  },

  async addDamage(data: WorkOrderChecklistDamageCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/Damage`,
      data,
    )) as unknown;

    return result as void;
  },

  async listDamage(params?: WorkOrderChecklistDamageListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetDamage`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistDamage[];
  },

  async sendFutureServiceToWorkorder(
    data: WorkOrderChecklistFutureServiceToWorkorder,
  ) {
    const result = (await api.post(
      `${CONTROLLER_URL}/SendFutureServiceToWorkOrder
      `,
      data,
    )) as unknown;

    return result as void;
  },

  async importFutureServiceExcludedServices(
    data: WorkOrderChecklistFutureServiceImportExcludedServices,
  ) {
    const result = (await api.post(
      `${CONTROLLER_URL}/ImportExcludedServices
      `,
      data,
    )) as unknown;

    return result as void;
  },

  async addFutureService(data: WorkOrderChecklistFutureServiceCreate) {
    const result = (await api.post(
      `${CONTROLLER_URL}/FutureService`,
      data,
    )) as unknown;

    return result as void;
  },

  async listFutureService(params?: WorkOrderChecklistFutureServiceListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/GetFutureService`,
      params,
    )) as unknown;

    return result as WorkOrderChecklistFutureService[];
  },

  async editFutureService(data: WorkOrderChecklistFutureServiceEdit) {
    const result = (await api.put(
      `${CONTROLLER_URL}/FutureService/${data.id}`,
      data,
      null,
    )) as unknown;

    return result as void;
  },

  async removeFutureService(id: number) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/FutureService/${id}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },

  async getChecklistReport(params?: ReportChecklistRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/report`,
      params,
    )) as ReportChecklistData;

    return result;
  },

  async getChecklistReportPublic(token?: string) {
    const result = await publicInstance.get<ReportChecklistPublicData>(
      `${CONTROLLER_URL}/reportPublic`,
      {
        params: { token },
      },
    );

    return result.data;
  },

  async getChecklistSignatureWithToken(
    params?: ChecklistSignatureWithTokenRequest,
  ) {
    const result = await publicInstance.post(
      `${CONTROLLER_URL}/Signature/with-token`,
      params,
    );

    return result.data;
  },

  async getChecklistObservations(params?: ChecklistObservationsListRequest) {
    const result = (await api.get(
      `${CONTROLLER_URL}/observations`,
      params,
    )) as unknown;

    return result as ChecklistObservationListResponse[];
  },

  async addChecklistObservation(data: ChecklistObservationRequest) {
    const result = (await api.post(
      `${CONTROLLER_URL}/observations`,
      data,
    )) as unknown;

    return result as void;
  },

  async editChecklistObservation(data: ChecklistObservationRequest) {
    const result = (await api.put(
      `${CONTROLLER_URL}/observations/${data.observationId}`,
      data,
      null,
    )) as unknown;

    return result as void;
  },

  async removeChecklistObservation(observationId: number) {
    const result = (await api.remove(
      `${CONTROLLER_URL}/observations/${observationId}`,
      {},
      null,
    )) as unknown;

    return result as void;
  },
};

export default workorderChecklistServices;
